import React from "react";
// import Grid from "@mui/material/Unstable_Grid2";
// import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import {OpenInNew} from '@mui/icons-material';

const binaryFallbackText = (value, labels = {}) => {
    const {
        yes = 'Yes.',
        no = 'No.',
        unclear = 'Unclear.'
    } = labels;

    if (value === true) {
        return yes;
    }

    if (value === false) {
        return no;
    }

    return unclear;
};

const descriptionOrBinaryText = (value, description, labels) => {
    const normalizedDescription = typeof description === 'string' ? description.trim() : '';
    return normalizedDescription || binaryFallbackText(value, labels);
};

const RepositoryDetails = (props) => {
    return ( <React.Fragment>
        <div style={{ margin: '30px 0 10px 0', display: 'flex' }}>
            <div style={{ minWidth: '100px', paddingTop: '9px' }}><b>Organisms: </b></div>
            <div>
                {props.repository.organisms && props.repository.organisms.map(organism =>
                    <Chip className='repository-chip' style={{ backgroundColor: '#D3F1FF' }} key={organism.id} label={organism['name']} />
                )}
                {props.repository.new_organisms && props.repository.new_organisms.map(org =>
                    <Chip className='repository-chip' style={{ backgroundColor: '#D3F1FF' }} key={org} label={org} />
                )}
            </div>
            <br />
        </div>

        <div style={{ marginBottom: '10px', display: 'flex' }}>
            <div style={{ minWidth: '135px', paddingTop: '9px' }}><b>Research Areas: </b></div>
            <div>
                {props.repository.research_areas && props.repository.research_areas.map(research_area =>
                    <Chip className='repository-chip' style={{ backgroundColor: '#D3F1FF' }} key={research_area.id} label={research_area['name']} />
                )}
                {props.repository.new_research_areas && props.repository.new_research_areas.map(ra =>
                    <Chip className='repository-chip' style={{ backgroundColor: '#D3F1FF' }} key={ra} label={ra} />
                )}
            </div>
            <br />
        </div>

        <div style={{ marginBottom: '10px', display: 'flex' }}>
            <div style={{ minWidth: '100px', paddingTop: '9px' }}><b>Data Types: </b></div>
            <div>
                {props.repository.data_types && props.repository.data_types.map(data_type =>
                    <Chip className='repository-chip' style={{ backgroundColor: '#D3F1FF' }} key={data_type.id} label={data_type['name']} />
                )}
                {props.repository.new_data_types && props.repository.new_data_types.map(dt =>
                    <Chip className='repository-chip' style={{ backgroundColor: '#D3F1FF' }} key={dt} label={dt} />
                )}
            </div>
            <br />
            <br />
        </div>

        <h3>Brief Description</h3>
        <div>
            {props.repository.description}
        </div>
        <br />

        <h3>Data Access Controls</h3>
        <span>{descriptionOrBinaryText(
            props.repository.data_access_controlled,
            props.repository.data_access_controlled_description,
            { unclear: 'Unclear data access controls.' }
        )}</span>
        { props.repository.data_access_controlled_url &&
        <div style={{padding: '15px 0'}}>
            <a href={props.repository['data_access_controlled_url']} target="_blank" rel="noreferrer">
                <Button size="small" variant="text" endIcon={<OpenInNew/>} className="text-button">
                    <b>Learn More</b>
                </Button>
            </a>
        </div>
        }

        <h3>Metadata Requirements</h3>
        <div>
            {/*{props.repository.metadata_required ? <span>Yes</span> : <span>No</span>}*/}
            <span>{descriptionOrBinaryText(
                props.repository.metadata_required,
                props.repository.metadata_required_description,
                { unclear: 'Unclear metadata requirements.' }
            )}</span>
            { props.repository.metadata_required_url &&
                <div style={{padding: '15px 0'}}>
                    <a href={props.repository['metadata_required_url']} target="_blank" rel="noreferrer">
                        <Button size="small" variant="text" endIcon={<OpenInNew/>} className="text-button">
                            <b>Learn More</b>
                        </Button>
                    </a>
                </div>
            }
        </div>

        <h3>Data Volume Limitations</h3>
        <span>{descriptionOrBinaryText(
            props.repository.data_volume_limited,
            props.repository.data_volume_description,
            { no: 'No limitations.' }
        )}</span>

        { props.repository.data_volume_url &&
        <div style={{padding: '15px 0'}}>
            <a href={props.repository['data_volume_url']} target="_blank" rel="noreferrer">
                <Button size="small" variant="text" endIcon={<OpenInNew/>} className="text-button">
                    <b>Learn More</b>
                </Button>
            </a>
        </div>
        }

        <h3>Individual-level Data</h3>
        <div>
            <span>{descriptionOrBinaryText(
                props.repository.accepts_individual_data,
                props.repository.accepts_individual_description
            )}</span>
            { props.repository.accepts_individual_url &&
                <div style={{padding: '15px 0'}}>
                    <a href={props.repository['accepts_individual_url']} target="_blank" rel="noreferrer">
                        <Button size="small" variant="text" endIcon={<OpenInNew/>} className="text-button">
                            <b>Learn More</b>
                        </Button>
                    </a>
                </div>
            }
        </div>

        <h3>De-Identification Standards and Guidelines</h3>
        <div>
            { (() => {
                if (props.repository.requires_deidentified_data) {
                    return( <span>Requires Specific De-Identification Method. {props.repository.deidentification_level}</span> );
                } else if( props.repository.requires_deidentified_data === null ) {
                    return( <span>No De-Identification Requirements Specified.</span> );
                } else {
                    return( <span>Not Applicable (No Human Data Accepted).</span> );
                }
            })() }
            { props.repository.requires_deidentified_data &&
                <div style={{padding: '15px 0'}}>
                    <a href={props.repository['deidentification_description']} target="_blank" rel="noreferrer">
                        <Button size="small" variant="text" endIcon={<OpenInNew/>} className="text-button">
                            <b>Learn More</b>
                        </Button>
                    </a>
                </div>
            }
        </div>


        <h3>Dataset-level Persistent IDs Used</h3>
        <span>{descriptionOrBinaryText(
            props.repository.persistent_id_used,
            props.repository.persistent_id_description
        )}</span>

        {props.repository.persistent_id_url &&
        <div style={{paddingTop: '15px'}}>
            <a href={props.repository['persistent_id_url']} target="_blank" rel="noreferrer">
                <Button size="small" variant="text" endIcon={<OpenInNew/>} className="text-button">
                    <b>Learn More</b>
                </Button>
            </a>
        </div>
        }

        <h3>Fee for Submission</h3>
        <div>
            <span>{descriptionOrBinaryText(
                props.repository.cost_to_submit,
                props.repository.costs_for_submit_description
            )}</span>
            {/* {props.repository.
                ? <span>{props.repository.cost_to_submit_description}</span>
                : <span>Unknown</span>
            }*/}
            {props.repository.costs_for_submission_url &&
            <div style={{paddingTop: '15px'}}>
                <a href={props.repository['costs_for_submission_url']} target="_blank" rel="noreferrer">
                    <Button size="small" variant="text" endIcon={<OpenInNew/>} className="text-button">
                        <b>Learn More</b>
                    </Button>
                </a>
            </div>
            }
        </div>

        <h3>Data Submission Requirements</h3>
        <div style={{whiteSpace: "pre-wrap"}}>{descriptionOrBinaryText(
            props.repository.data_submission_reqs,
            props.repository.data_submission_reqs_description,
            { no: 'None listed.' }
        )}</div>
        {props.repository.data_submission_reqs_url &&
            <div style={{paddingTop: '15px'}}>
                <a href={props.repository['data_submission_reqs_url']} target="_blank" rel="noreferrer">
                    <Button size="small" variant="text" endIcon={<OpenInNew/>} className="text-button">
                        <b>Learn More</b>
                    </Button>
                </a>
            </div>
        }


            <div style={{ marginBottom: '10px' }}>

                <h3>Accepted Data Formats</h3>
                { props.repository.data_formats &&
                props.repository.data_formats.map(data_format =>
                    <span key={data_format.id}>{data_format['name']}, </span>
                )}
                {props.repository.new_data_formats && props.repository.new_data_formats.map(df =>
                    <span key={df}>{df}, </span>
                )}
                {props.repository.data_formats &&
                <><br/><br/></>
                }
                { props.repository.formats_accepted_description &&
                    <><span>{props.repository.formats_accepted_description}</span><br/><br/></>
                }
            </div>

            {props.repository.formats_accepted_url &&
                <div style={{padding: '15px 0'}}>
                    <a href={props.repository['formats_accepted_url']} target="_blank" rel="noreferrer">
                        <Button size="small" variant="text" endIcon={<OpenInNew/>} className="text-button">
                            <b>Learn More</b>
                        </Button>
                    </a>
                </div>
            }

        <div style={{ marginBottom: '10px' }}>
            <h3>Data Submission Agreement or Institutional Certification Required</h3>
            <span>{descriptionOrBinaryText(
                props.repository.dua_or_cert_required,
                props.repository.dua_or_cert_required_description,
                { unclear: 'Unclear agreement requirements.' }
            )}</span>

            <br />
            <br />
        </div>

        {props.repository.dua_or_cert_required_url &&
        <div style={{padding: '15px 0'}}>
            <a href={props.repository['dua_or_cert_required_url']} target="_blank" rel="noreferrer">
                <Button size="small" variant="text" endIcon={<OpenInNew/>} className="text-button">
                    <b>Learn More</b>
                </Button>
            </a>
        </div>
        }

     <h3>Private Sharing Option</h3>
        <div>
            { (() => {
                if (props.repository.private_sharing) {
                    return( <span>This repository has a private sharing feature.</span> );
                } else if( props.repository.private_sharing === null ) {
                    return( <span>It is unclear if this repository has a private sharing feature. </span> );
                } else {
                    return( <span>This repository does not have a private sharing feature.</span> );
                }
            })() }
            { props.repository.private_sharing_url &&
                <div style={{padding: '15px 0'}}>
                    <a href={props.repository['private_sharing_url']} target="_blank" rel="noreferrer">
                        <Button size="small" variant="text" endIcon={<OpenInNew/>} className="text-button">
                            <b>Learn More</b>
                        </Button>
                    </a>
                </div>
            }
        </div>

    </React.Fragment> );
}

export default RepositoryDetails;